import { defineStore } from 'pinia'
import { ref } from 'vue'
import { sdk } from '@/graphql/client'

export interface AuthDevice {
    name: string
}

export const useAuthStore = defineStore('auth', () => {
    const user = ref<AuthDevice | null>(null)
    // Username from last successful login. Server doesn't return it, so we keep it client-side.
    const username = ref<string | null>(null)

    async function getUserStatus(): Promise<AuthDevice | null> {
        const result = await sdk.UserLogged()
        const device = result.mobile?.userLogged?.device ?? null
        user.value = device ? { name: device.name ?? '' } : null
        if (!user.value) username.value = null
        return user.value
    }

    async function loginUser(input: { username: string; password: string }) {
        const result = await sdk.LoginUser(input)
        const data = result.mobile?.login
        if (!data) {
            return { ok: false, message: 'No response', device: null as AuthDevice | null }
        }
        if (data.ok && data.device) {
            user.value = { name: data.device.name ?? '' }
            username.value = input.username
        }
        return {
            ok: Boolean(data.ok),
            message: data.message ?? null,
            device: data.device ? { name: data.device.name ?? '' } : null
        }
    }

    async function logoutUser() {
        const result = await sdk.LogoutUser()
        const ok = Boolean(result.mobile?.logout?.ok)
        if (ok) {
            user.value = null
            username.value = null
        }
        return { ok }
    }

    return { user, username, getUserStatus, loginUser, logoutUser }
})
